import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_RS.json';
import guides from './MEDITATION_GUIDES_RS.json';

export const MEDITATION_DATA_RS: ServiceData = {
  audios,
  guides,
};
